import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

export function useSubscriptionsTranslation(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.SUBSCRIPTIONS, { keyPrefix });
  return t;
}
